const createBulkUpsertBatchDetails = require('../batch/upsert-batch-details')
const { fsShipmentDateParser } = require('../shipment/tools/safe-date-parser')

function createBatchHelpers ({ mainApi, logger }) {
  const bulkUpsertBatchDetails = createBulkUpsertBatchDetails({ mainApi, logger })

  async function fromGrn (items = []) {
    const batchItems = items
      .filter(item => item && item.batch_number && item.expiry_date)
      .map(item => ({
        skuCode: item.sku_code,
        batchNo: item.batch_number,
        expiry: new Date(fsShipmentDateParser(item.expiry_date)).toJSON()
      }))
    await bulkUpsertBatchDetails(batchItems)
  }

  async function fromRtv (items = []) {
    const batchItems = items
      .filter(item => item && item.batch_no && item.expiry_date)
      .map(item => ({
        skuCode: item.sku_code,
        batchNo: item.batch_no,
        expiry: new Date(item.expiry_date).toJSON()
      }))
    await bulkUpsertBatchDetails(batchItems)
  }

  async function fromInvoice (items = []) {
    const batchItems = []
    for (const item of items) {
      const batches = Array.isArray(item.batch_details) ? item.batch_details : []
      for (const batch of batches) {
        if (!batch || !batch.batch_no || !batch.expiry_date) continue
        batchItems.push({
          skuCode: item.sku_code,
          batchNo: batch.batch_no,
          expiry: new Date(batch.expiry_date).toJSON()
        })
      }
    }
    await bulkUpsertBatchDetails(batchItems)
  }

  async function fromSalesReturn (items = []) {
    const batchItems = items
      .filter(item => item && item.batch_number)
      .map(item => ({
        skuCode: item.sku_code,
        batchNo: item.batch_number,
        expiry: new Date(item.expiry_date).toJSON() || new Date('2099-12-31').toJSON()
      }))
    await bulkUpsertBatchDetails(batchItems)
  }

  return {
    fromGrn,
    fromRtv,
    fromInvoice,
    fromSalesReturn,
    bulkUpsertBatchDetails
  }
}

module.exports = createBatchHelpers
